import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8f3792c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rel amount-set" }

import { computed } from 'vue'
import ToolTipLadder from '@/views/goods/components/ToolTipLadder.vue'
import { sourceCountryInfo } from '../country'

export default /*#__PURE__*/_defineComponent({
  props: ['amount', 'min', 'max', 'disabled', 'goods', 'sourceCountryInfo'],
  emits: ['update:amount'],
  setup(__props, { emit }) {

const props = __props
console.log(sourceCountryInfo, 'sourceCountryInfo')




const value = computed({
  get: () => props.amount,
  set: (v) => emit('update:amount', v)
})

const minus = () => {
  if (props.disabled) return
  emit('update:amount', Math.max(1, value.value - 1))
}
const add = () => {
  if (props.disabled) return
  emit('update:amount', Math.min(999999, value.value + 1))
}

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createBlock(ToolTipLadder, {
    sourceCountryInfo: _unref(sourceCountryInfo),
    ladder: __props.goods?.productPriceLadderList,
    minCount: __props.goods?.minOrderQuantity,
    num: 0,
    saleType: 1,
    placement: "top"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", {
          class: "btn minus",
          onClick: minus,
          style: _normalizeStyle({ cursor: __props.disabled ? 'not-allowed' : '' })
        }, " - ", 4),
        _createVNode(_component_el_input_number, {
          class: "fx-1",
          controls: false,
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          max: 999999,
          min: __props.min,
          disabled: __props.disabled,
          "step-strictly": ""
        }, null, 8, ["modelValue", "min", "disabled"]),
        _createElementVNode("label", {
          class: "btn add",
          onClick: add,
          style: _normalizeStyle({ cursor: __props.disabled ? 'not-allowed' : '' })
        }, " + ", 4),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["sourceCountryInfo", "ladder", "minCount"]))
}
}

})